/* ============================================================
   BLUMAT DRIP — AJAX SIDE CART
   ============================================================ */

const BM_FREE_SHIPPING_THRESHOLD = 2500; // $25.00 in cents

let bmCartOpen = false;

function bmFormatPrice(cents) {
  return '$' + (cents / 100).toFixed(2);
}

async function bmFetchCart() {
  const res = await fetch('/cart.js');
  return res.json();
}

async function bmAddToCart(variantId, qty = 1, properties = {}) {
  const res = await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: qty, properties }),
  });
  return res.json();
}

async function bmChangeCartItem(line, qty) {
  const res = await fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ line, quantity: qty }),
  });
  return res.json();
}

function bmUpdateShippingBar(subtotal) {
  const textEl = document.getElementById('bm-shipping-text');
  const fillEl = document.getElementById('bm-shipping-fill');
  const trackEl = fillEl && fillEl.parentElement;
  if (!textEl || !fillEl) return;

  const remaining = BM_FREE_SHIPPING_THRESHOLD - subtotal;
  const pct = Math.min(100, (subtotal / BM_FREE_SHIPPING_THRESHOLD) * 100);

  // Inline-style the track + fill so any external CSS conflict can't hide them.
  if (trackEl) {
    trackEl.style.cssText = 'display:block;width:100%;height:8px;background:#DDE4D4;border-radius:999px;overflow:hidden;';
  }
  fillEl.style.cssText = 'display:block;height:100%;width:' + pct + '%;background:#C4D600;border-radius:999px;transition:width 0.4s cubic-bezier(0.22,1,0.36,1);';

  if (remaining <= 0) {
    textEl.innerHTML = 'You qualify for <strong>free shipping!</strong>';
  } else {
    textEl.innerHTML = 'Add <strong>' + bmFormatPrice(remaining) + '</strong> more for free shipping';
  }
}

function bmUpdateCartBadge(count) {
  // Drawer header count
  const countEl = document.getElementById('bm-side-cart-count');
  if (countEl) countEl.textContent = count;

  // Header icon bubble — hidden attr drives visibility
  document.querySelectorAll('[data-bm-cart-count]').forEach(function (el) {
    el.textContent = count;
  });
  document.querySelectorAll('[data-bm-cart-bubble]').forEach(function (el) {
    if (count > 0) el.removeAttribute('hidden');
    else el.setAttribute('hidden', '');
  });
}

function bmEscapeHtml(str) {
  return String(str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

function bmRenderCart(cart) {
  const emptyEl = document.getElementById('bm-cart-empty');
  const itemsEl = document.getElementById('bm-cart-items');
  const subtotalEl = document.getElementById('bm-cart-subtotal');
  const footerEl = document.getElementById('bm-cart-footer');

  bmUpdateCartBadge(cart.item_count);

  if (subtotalEl) subtotalEl.textContent = bmFormatPrice(cart.total_price);

  bmUpdateShippingBar(cart.total_price);

  if (cart.item_count === 0) {
    if (itemsEl) itemsEl.innerHTML = '';
    if (emptyEl) emptyEl.style.display = 'flex';
    if (footerEl) footerEl.style.display = 'none';
    return;
  }

  if (emptyEl) emptyEl.style.display = 'none';
  if (footerEl) footerEl.style.display = 'flex';

  if (!itemsEl) return;

  itemsEl.innerHTML = cart.items.map(function(item, index) {
    const line = index + 1;
    const imgSrc = item.image
      ? item.image
      : 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="72" height="72"%3E%3Crect fill="%23EFF1E4" width="72" height="72"/%3E%3C/svg%3E';
    const variantTitle = item.variant_title && item.variant_title !== 'Default Title'
      ? item.variant_title : '';

    return (
      '<div class="bm-cart-item" data-line-index="' + line + '">' +
        '<div class="bm-cart-item__image"><img src="' + imgSrc + '" alt="' + bmEscapeHtml(item.product_title) + '" width="72" height="72" loading="lazy"></div>' +
        '<div class="bm-cart-item__info">' +
          '<p class="bm-cart-item__name">' + bmEscapeHtml(item.product_title) + '</p>' +
          (variantTitle ? '<p class="bm-cart-item__variant">' + bmEscapeHtml(variantTitle) + '</p>' : '') +
          '<div class="bm-cart-item__price-row">' +
            '<span class="bm-cart-item__price">' + bmFormatPrice(item.line_price) + '</span>' +
            '<div class="bm-cart-item__qty">' +
              '<button class="bm-cart-item__qty-btn" data-action="decrease" aria-label="Decrease quantity">&#8722;</button>' +
              '<span class="bm-cart-item__qty-num">' + item.quantity + '</span>' +
              '<button class="bm-cart-item__qty-btn" data-action="increase" aria-label="Increase quantity">&#43;</button>' +
            '</div>' +
          '</div>' +
        '</div>' +
        '<button class="bm-cart-item__remove" data-line-index="' + line + '" aria-label="Remove ' + bmEscapeHtml(item.product_title) + '">' +
          '<svg viewBox="0 0 14 14"><path d="M2 2l10 10M12 2L2 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" fill="none"/></svg>' +
        '</button>' +
      '</div>'
    );
  }).join('');
}

function bmOpenCart() {
  if (bmCartOpen) return;
  bmCartOpen = true;
  const panel = document.getElementById('bm-side-cart');
  let backdrop = document.getElementById('bm-cart-backdrop');
  // Defensive: if the backdrop div somehow isn't in the DOM, create it on the fly.
  if (!backdrop) {
    backdrop = document.createElement('div');
    backdrop.id = 'bm-cart-backdrop';
    backdrop.className = 'bm-cart-backdrop';
    document.body.appendChild(backdrop);
  }
  if (panel) { panel.classList.add('bm-side-cart--open'); panel.removeAttribute('aria-hidden'); }
  backdrop.classList.add('bm-cart-backdrop--open');
  // Inline styles override any external CSS that might be hiding the backdrop.
  backdrop.style.cssText = 'position:fixed;inset:0;width:100vw;height:100vh;background:rgba(0,0,0,0.55);z-index:800;opacity:1;visibility:visible;pointer-events:auto;display:block;';
  document.body.classList.add('bm-cart-is-open');
  document.body.style.overflow = 'hidden';
  const closeBtn = panel && panel.querySelector('.bm-side-cart__close');
  if (closeBtn) closeBtn.focus();
}

function bmCloseCart() {
  if (!bmCartOpen) return;
  bmCartOpen = false;
  const panel = document.getElementById('bm-side-cart');
  const backdrop = document.getElementById('bm-cart-backdrop');
  if (panel) { panel.classList.remove('bm-side-cart--open'); panel.setAttribute('aria-hidden', 'true'); }
  if (backdrop) {
    backdrop.classList.remove('bm-cart-backdrop--open');
    backdrop.style.cssText = '';
  }
  document.body.classList.remove('bm-cart-is-open');
  document.body.style.overflow = '';
}

document.addEventListener('DOMContentLoaded', function() {
  bmFetchCart().then(bmRenderCart);

  // Add-to-cart
  document.addEventListener('click', async function(e) {
    const btn = e.target.closest('[data-add-to-cart]');
    if (!btn) return;
    e.preventDefault();

    const variantId = btn.dataset.variantId;
    if (!variantId) return;

    const originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding\u2026';

    try {
      await bmAddToCart(variantId, 1);
      const cart = await bmFetchCart();
      bmRenderCart(cart);
      bmOpenCart();
    } catch (err) {
      console.error('[BM Cart] Add to cart failed:', err);
    } finally {
      btn.disabled = false;
      btn.textContent = originalText;
    }
  });

  // Qty +/-
  document.addEventListener('click', async function(e) {
    const btn = e.target.closest('.bm-cart-item__qty-btn');
    if (!btn) return;

    const item = btn.closest('.bm-cart-item');
    if (!item) return;

    const line = parseInt(item.dataset.lineIndex, 10);
    const valEl = item.querySelector('.bm-cart-item__qty-num');
    if (!valEl) return;

    let qty = parseInt(valEl.textContent, 10);
    qty = btn.dataset.action === 'increase' ? qty + 1 : Math.max(0, qty - 1);

    try {
      const cart = await bmChangeCartItem(line, qty);
      bmRenderCart(cart);
    } catch (err) {
      console.error('[BM Cart] Change qty failed:', err);
    }
  });

  // Remove
  document.addEventListener('click', async function(e) {
    const btn = e.target.closest('.bm-cart-item__remove');
    if (!btn) return;

    const line = parseInt(btn.dataset.lineIndex, 10);

    try {
      const cart = await bmChangeCartItem(line, 0);
      bmRenderCart(cart);
    } catch (err) {
      console.error('[BM Cart] Remove failed:', err);
    }
  });

  // Close: close button, continue shopping, backdrop
  document.addEventListener('click', function(e) {
    if (
      e.target.closest('#bm-cart-close') ||
      e.target.closest('#bm-cart-continue') ||
      e.target.id === 'bm-cart-backdrop'
    ) {
      bmCloseCart();
    }
  });

  // Header cart icon click → open drawer instead of navigating to /cart
  document.addEventListener('click', function(e) {
    const trigger = e.target.closest('[data-bm-open-cart]');
    if (!trigger) return;
    e.preventDefault();
    bmFetchCart().then(function (cart) {
      bmRenderCart(cart);
      bmOpenCart();
    });
  });

  // ESC key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') bmCloseCart();
  });

  // Custom event from ATC buttons elsewhere (e.g. sticky ATC, FBT)
  document.addEventListener('bm:cart:open', function() {
    bmFetchCart().then(function(cart) {
      bmRenderCart(cart);
      bmOpenCart();
    });
  });

  // Dawn header cart icon intercept
  const cartIcon = document.querySelector('#cart-icon-bubble');
  if (cartIcon) {
    cartIcon.addEventListener('click', function(e) {
      e.preventDefault();
      bmFetchCart().then(function(cart) {
        bmRenderCart(cart);
        bmOpenCart();
      });
    });
  }
});
